import * as firebase from "firebase/app";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";
import * as auth from "firebase/auth";
import * as database from "firebase/database";
import * as firestore from "firebase/firestore";
import * as fbFunctions from "firebase/functions";
import * as storage from "firebase/storage";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID,
  databaseURL: process.env.REACT_APP_DATABASE_URL,
};

const app = firebase.initializeApp(firebaseConfig);

if (process.env.REACT_APP_NODE_ENV === "local") {
  // @ts-ignore
  // eslint-disable-next-line no-restricted-globals
  self.FIREBASE_APPCHECK_DEBUG_TOKEN = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
}

initializeAppCheck(app, {
  provider: new ReCaptchaV3Provider(
    process.env.REACT_APP_RECAPTCHA_SITE_KEY || "",
  ),
  isTokenAutoRefreshEnabled: true, // Set to true to allow auto-refresh.
});

export const authClient = auth.getAuth(app);
export const store = storage.getStorage();
export const functions = fbFunctions.getFunctions(app);

export const db = firestore.getFirestore();
export const rtdb = database.getDatabase();
export const { FieldValue } = firestore;

export const dateToTimestamp = (date: Date) =>
  firestore.Timestamp.fromDate(date);

export type DocumentReference<T> = firestore.DocumentReference<T>;
export type FirestoreError = firestore.FirestoreError;
export type CollectionReference<T> = firestore.CollectionReference<T>;
export type Query<T> = firestore.Query<T>;
export type DocumentSnapshot<T> = firestore.DocumentSnapshot<T>;
export type QuerySnapshot<T> = firestore.QuerySnapshot<T>;
export type QueryDocumentSnapshot<T> = firestore.QueryDocumentSnapshot<T>;
export type DocumentData = firestore.DocumentData;
export type Timestamp = firestore.Timestamp;

export default app;

if (process.env.REACT_APP_USE_EMULATOR === "true") {
  console.warn("WARN: Using emulator suite");

  auth.connectAuthEmulator(authClient, "http://127.0.0.1:9099");
  database.connectDatabaseEmulator(rtdb, "127.0.0.1", 9000);
  firestore.connectFirestoreEmulator(db, "127.0.0.1", 8080);
  storage.connectStorageEmulator(store, "127.0.0.1", 9199);
  fbFunctions.connectFunctionsEmulator(functions, "127.0.0.1", 5001);
}
